import { StepHandle } from "..";
import { materialStepService } from "../../services/steps/material";
import { MaterialStepData, Step } from "../../types";
import { WorkflowManager } from "../../WorkflowManager";
import { Variant } from "../resource/variant";

export class MaterialStepHandle extends StepHandle<MaterialStepData> {
    constructor(manager: WorkflowManager, step: Step<MaterialStepData>, tags: string[]) {
        super(manager, step, tags);
    }

    selectVariant(variant: Variant) {
        return materialStepService.selectVariant(this.step, variant.getResource(), this.manager, (val) =>
            this.setUpdateState(val),
        );
    }
}
